import { format, isValid } from 'date-fns';
import { stringToDate } from '@petconsole/pure-base';
import { dateFormat } from '../constants';

const ourStringToDisplayDate = (str: string | null) => {
  const date = stringToDate(str);

  return date && isValid(date) ? format(date, dateFormat.displayDate) : 'Invalid Date';
};

export default ourStringToDisplayDate;
